import React, { Component } from 'react';
import './about.css';

class About extends Component {
  render() {
    return (
      <div className="about">
        <div>
          <h4>What I Do</h4>
        </div>
        <p>
          I work with multitude of different technologies. Starting from&nbsp;
          <span>web dev</span>, 
          through&nbsp;
          <span>mobile</span>,
          looking into&nbsp;
          <span>games dev</span>,
          stopping for a second at&nbsp;
          <span>Augmented and Virtual Realities</span>,
           testing&nbsp;
           <span>Deep Neural Networks</span> and&nbsp;
           <span>Natural Language Processing</span>.<br />
          Sometimes grabbing soldering iron and connecting&nbsp;
          <span>Arduino</span>&nbsp;
          through breadboard to ECU at two wheels.<br />
          When I encounter something to solve in real life, I try to figure out can I use my skills to improve workflow, simply because
        </p>
        <h4>Technology Is Awesome</h4>
      </div>
    );
  }
}

export default About;



/** WEBPACK FOOTER **
 ** ./src/about/about.js
 **/